module.exports = __webpack_public_path__ + "static/img/ceo-pic.42ce6486.png";